import type { DraftPoint } from "../scene/draftingHelpers";

export function toTestIdSegment(value: string): string {
  return value
    .replace(/[^a-z0-9]+/giu, "-")
    .replace(/^-+|-+$/g, "")
    .toLowerCase();
}

export function formatCommandPoint(point: DraftPoint): string {
  return `${formatDraftNumber(point.x)},${formatDraftNumber(point.y)}`;
}

export function formatDraftNumber(value: number): string {
  return Number.isInteger(value)
    ? String(value)
    : value.toFixed(3).replace(/\.?0+$/u, "");
}
